import React from 'react';
import { Fade } from "react-awesome-reveal";
import { Link } from 'react-scroll';

function DropdownMenu() {
  return (
    <div className="dropdown">
      <Link to="aboutSection" spy={true} smooth={true} duration={700}>
        <Fade direction="down">
          <div className="menu-item">
            About
          </div>
        </Fade>
      </Link>
      <Link to="skillsSection" spy={true} smooth={true} duration={700}>
        <Fade direction="down">
          <div className="menu-item">
            Skills
          </div>
        </Fade>
      </Link>
      <Link to="projectsSection" spy={true} smooth={true} duration={700}>
        <Fade direction="down">
          <div className="menu-item">
            Projects
          </div>
        </Fade>
      </Link>
      <Link to="hobbiesSection" spy={true} smooth={true} duration={700}>
        <Fade direction="down">
          <div className="menu-item">
            Hobbies
          </div>
        </Fade>
      </Link>
      <Link to="contactSection" spy={true} smooth={true} duration={700}>
        <Fade direction="down">
          <div className="menu-item">
            Contact
          </div>
        </Fade>
      </Link>
    </div>
  )
}

export default DropdownMenu;